import { Types } from '../constants/actionTypes';

const initialState = {
    app_details: {
        "app_id": "",
        "theme_colour": "",
        "short_name": "",
        "introduction": "",
        "logo": "",
        "slides": [],
        "name": "",
        "full_text": ""
    }
}

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case Types.UPDATE_APP_DETAILS:
            return {
                ...state,
                appData: action.payload,
            }
        default:
            return state;
    }
}

export default reducer;